export const songs=[
  {
  	name: "last_resort",
  	poster: "thumbnails/last resort.jpg",
  	// link: "https://drive.google.com/uc?export=download&id=1j3sVMgzLQId9BmJxpC0KMMNu4Rn6mTlu",
    link : 'https://od.lk/s/OF8xODc2NDU0NTlf/Eagles%20The%20Last%20Resort%20Paradise%20The%20Last%20Resort%20lyrics%20on%20screen%20description_480p.mp4',
  	// link: "videos/The Last Resort.mp4",
  	title: "Last Resort   --Eagles"
  },
  {
  	name: "numb",
  	poster: "thumbnails/numb.jpg",
  	// link: "https://drive.google.com/uc?export=download&id=1gKk_WUj2y_KWkuUPcxJh9WmpesWV8VLL",
    link : 'https://od.lk/s/OF8xODc2NDU0NTNf/Numb.mp4',
  	// link: "videos/Numb.mp4",
  	title: "Numb   --Linkin Park"
  },
  {
  	name: "you_know_my_name",
  	poster: "thumbnails/you_know_my_name.jpg",
  	// link: "https://drive.google.com/uc?export=download&id=1FZjZshWtvmL-iqeXwMkYibTQ0wG3cU9S",
    link : 'https://od.lk/s/OF8xODc2NDU0NDNf/You%20Know%20My%20Name%20-%20Chris%20Cornell%20-%20James%20Bond%20Casino%20Royale_360p.mp4',
  	// link: "videos/You Know My Name.mp4" ,
  	title: "You Know My Name   --Chris Cornell"
  },
  {
  	name: "nobody_can_save_me",
  	poster: "thumbnails/nobody can save me.jpg",
  	// link: "https://drive.google.com/uc?export=download&id=1ZLl-y2siOBhwep1ByR2uMOiFQ5sKEer5",
    link : 'https://od.lk/s/OF8xODc2NDU0MzBf/Linkin%20Park%20Nobody%20Can%20Save%20Me%20Lyrics%20Video_480p.mp4',
  	title: "Nobody Can Save Me   --Linkin Park"
  },
  {
  	name: "a_place_for_my_head",
  	poster: "thumbnails/a place for my head.jpg",
  	// link: "https://drive.google.com/uc?export=download&id=1RKBbUdDoA93hQIK6_qvvL5Zw62zYQzSn",
    link : 'https://od.lk/s/OF8xODc2NDUzOTNf/Linkin%20Park%20A%20Place%20For%20My%20Head%20Lyrics%20on%20screen%20HD_480p.mp4',
  	title: "A Place For My Head   --Linkin Park"
  },
  {
  	name: "start_again",
  	poster: "thumbnails/start again.jpg",
  	// link: "https://drive.google.com/uc?export=download&id=14e67INwkwKjw9e8ma2ftv0G5IwVTdWnv",
    link : 'https://od.lk/s/OF8xODc2NDUzNjdf/480p%20OneRepublic%20Start%20Again%20ft%20Logic%20Official%20Music%20Video_480p.mp4',
  	title: "Start Again   --One Republic"
  },
  {
  	name: "waiting_for_the_end",
  	poster: "thumbnails/waiting for the end.jpg",
  	// link: "https://drive.google.com/uc?export=download&id=1TeIShqHo6nUe0lLx7Z25Wn-YPHcM0XwB",
    link : 'https://od.lk/s/OF8xODc2NDUzMTZf/Linkin%20Park%20Waiting%20For%20The%20End%20lyrics_480p.mp4',
  	title: "Waiting For The End   --Linkin Park"
  },
  {
  	name: "lost_in_the_echo",
  	poster: "thumbnails/lost in the echo.jpg",
  	// link: "https://drive.google.com/uc?export=download&id=11--hDMx3SHDIkFfSBuJzw8zwYiGYLnOK",
    link : 'https://od.lk/s/OF8xODc2NDUxMzlf/480p%20LOST%20IN%20THE%20ECHO%20Official%20Video%20Linkin%20Park_480p.mp4',
  	title: "Lost In The Echo   --Linkin Park"
  },
  {
  	name: "i_was_never_there",
  	poster: "thumbnails/i was never there.jpg",
  	// link: "https://drive.google.com/uc?export=download&id=1bbuXWJFGrYAA3y3upKfVabslur_dUKS1", 
    link : 'https://od.lk/s/OF8xODc2NDUyODZf/The%20Weeknd%20I%20Was%20Never%20There%20lyrics%20_480p.mp4',
  	title: "I Was Never There   --Weeknd"
  },
  {
  	name: "what_we_dont_know",
  	poster: "thumbnails/what we dont know.jpg",
  	// link: "https://drive.google.com/uc?export=download&id=1xlbfdpB-25IE86HE_Ah2z6woGwnV8Zxv",
    link : 'https://od.lk/s/OF8xODc2NDUyMTlf/y2mate.com%20-%20Linkin%20Park%20What%20We%20Don%27t%20Know%20-%20Lyrics_faGp316ZT8k_720p.mp4',
  	title: "What We Don't Know   --Linkin Park"
  },
  {
  	name: "twenty_eight",
  	poster: "thumbnails/twenty eight.jpg",
  	// link: "https://drive.google.com/uc?export=download&id=1XLHacVf5CvAg3nCV7leL5oWuuiVhNmnP",
    link : 'https://od.lk/s/OF8xODc2NDUyNTJf/The%20Weeknd%20-%20Twenty%20Eight%20%5BHQ%5D%20%28Lyrics%20on%20Screen%29_HIGH.mp4',
  	title: "Twenty Eight   --Weeknd"
  },
  
  {
  	name: "faith",
  	poster: "thumbnails/faith.jpg",
  	// link: "https://drive.google.com/uc?export=download&id=1zY0oWruZL9arGMYvbNZ9jt0FgPuaf-l_",
    link : 'https://od.lk/s/OF8xODc2NDUxODRf/The%20Weeknd%20-%20Faith%20%28Lyrics%29_HIGH.mp4',
  	title: "Faith   --Weeknd"
  },
  {
  	name: "papercut",
  	poster: "thumbnails/papercut.jpg",
  	// link: "https://drive.google.com/uc?export=download&id=1ZPt9l-DWGWAgdF2FOz6cJamjpGi2So_B",
    link : 'https://od.lk/s/OF8xODc2NDQ4Mzdf/Papercut%20%28Official%20Video%29%20-%20Linkin%20Park_HIGH.mp4',
  	title: "Papercut   --Linkin Park"
  },
  {
  	name: "the_town",
  	poster: "thumbnails/the town.jpg",
  	// link: "https://drive.google.com/uc?export=download&id=1alEqIaaypbmAS2P5aFoVgiis-VIG7MqI",
    link : 'https://od.lk/s/OF8xODc2NDQ5MjRf/480p-%20The%20Weeknd%20The%20Town%20Lyrics_480p.mp4',
  	title: "The Town   --Weeknd"
  },
  {
  	name: "high_for_this",
  	poster: "thumbnails/high_for_this.jpg",
  	// link: 'https://drive.google.com/uc?export=download&id=1RSNkOJlys-fT3YSSaiBH4l9H7c5_Foop' ,
    link : 'https://od.lk/s/OF8xODc2NDQ5NjZf/The%20Weeknd%20-%20High%20For%20This%20%28LYRICS%29_HD.mp4',
  	title: "High For This  --Weeknd"
  },

  {
    name : 'bohemian_rhapsody',
    poster : 'thumbnails/bohemian rhapsody.jpg',
    link : 'https://od.lk/s/OF8xODc2NDU5Mjhf/Queen%20Bohemian%20Rhapsody%20Official%20Video%20Remastered_480p.mp4',
    title : "Bohemian Rhapsody   --Queen"
  },
  {
    name : 'jesus_of_suburbia',
    poster: 'thumbnails/jesus of suburbia.jpg',
    link : 'https://od.lk/s/OF8xODc2NDU5Njdf/Green%20Day%20Jesus%20of%20Suburbia%20Lyrics%20HD_480p.mp4',
    title : "Jesus Of Suburbia   --Green Day"
  }
];

